import type { KeyboardEvent } from "react";
import Select from "react-select";

export interface SearchableSelectProps {
  customKey: string;
  defaultValue?: any;
  onOptionSelect: (option: any) => void;
  options: any[];
  placeholder?: string;
  searchable: boolean;
  selected: string;
}

/** @deprecated Please use the new SearchableSelect at "@circle-react-uikit/SearchableSelect" */
export const SearchableSelect_DEPRECATED = ({
  options = [],
  customKey,
  selected,
  searchable = true,
  onOptionSelect,
  defaultValue,
  placeholder,
}: SearchableSelectProps) => {
  const onKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };

  return (
    <div className="form-input">
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment -- react-select type incompatibility with React 18, component is deprecated */}
      {/* @ts-ignore - react-select type incompatibility with React 18, component is deprecated */}
      <Select
        key={customKey}
        options={options}
        onChange={onOptionSelect}
        isSearchable={searchable}
        value={options.filter(option => option.value == selected)}
        onKeyDown={onKeyDown}
        className="react-searchable-select"
        classNamePrefix="react-searchable-select"
        defaultValue={defaultValue}
        placeholder={placeholder}
      />
    </div>
  );
};
